export default __webpack_public_path__ + "static/media/妹塔宇宙.5b103fad.png";